import { Box, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { ContractsEmployeesContractVersionFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import { translate } from 'modules/contracts/lib/translate'

import ContractDates from './ContractDates'
import { stepHasErrors } from './validator'

interface Props {
  form: Form
  translations: { [key: string]: string }
  step: number
  type: ContractFlowType
  setIsCurrentStepCompleted: (isCompleted: boolean) => void
  contractVersionId?: string
  contractVersions: ContractsEmployeesContractVersionFragment[]
  isFixedDiscontinuousContract?: boolean
}

const Dates = ({
  form,
  translations,
  step: _step,
  type,
  setIsCurrentStepCompleted,
  contractVersionId,
  contractVersions,
  isFixedDiscontinuousContract,
}: Props) => {
  const effectiveOnField = form.get('effective_on')
  const startsOnField = form.has('starts_on') ? form.get('starts_on') : undefined

  useUnsafeEffect(() => {
    setIsCurrentStepCompleted(
      !stepHasErrors(form, contractVersions, type) && effectiveOnField.hasValue
    )
  }, [
    effectiveOnField.value,
    startsOnField?.value,
    contractVersions,
    effectiveOnField.hasValue,
    setIsCurrentStepCompleted,
    form,
    type,
  ])

  return (
    <Box gap="s32" paddingBottom="s40">
      <FormWrapper>
        <Text size="400" weight="medium" color="grey1000">
          {translate(translations, 'header')}
        </Text>
      </FormWrapper>
      <FormWrapper>
        <ContractDates
          form={form}
          type={type}
          contractVersionId={contractVersionId}
          translations={translations}
          contractVersions={contractVersions}
          isFixedDiscontinuousContract={isFixedDiscontinuousContract}
        />
      </FormWrapper>
    </Box>
  )
}

export default observer(Dates)
